import { moduleRoutes } from './moduleRoutes'
import { RouteNames } from './routeNames'
import type { RvaiRouteRecord } from './types'


// We need to ignore "imports" for components properties in routes,
// because without it we have no possibility to import (dynamically) pages for specific router.
// Normally we don't need to import something from "pages" into router,
// but eslint doesn't know the difference between normal and dynamic imports.
const routes: RvaiRouteRecord<RouteNames>[] = [
  {
    path: '/',
    redirect: { name: RouteNames.Projects },
  },

  {
    // eslint-disable-next-line import/no-restricted-paths
    component: () => import('../pages/Login.vue'),
    meta: {
      anonymous: true,
      redirectable: false,
      track: false,
    },
    name: RouteNames.Login,
    path: '/login',
  },

  {
    // eslint-disable-next-line import/no-restricted-paths
    component: () => import('../pages/SignUp.vue'),
    meta: {
      anonymous: true,
      redirectable: false,
    },
    name: RouteNames.SignUp,
    path: '/signup',
  },

  ...moduleRoutes,

  {
    // eslint-disable-next-line import/no-restricted-paths
    component: () => import('../pages/ErrorNetwork.vue'),
    meta: {
      anonymous: true,
      redirectable: false,
      track: false,
    },
    name: RouteNames.NetworkError,
    path: '/network-error',
  },
  {
    // eslint-disable-next-line import/no-restricted-paths
    component: () => import('../pages/ErrorToken.vue'),
    meta: {
      anonymous: true,
      redirectable: false,
    },
    name: RouteNames.ErrorToken,
    path: '/error-token',
  },
  {
    // eslint-disable-next-line import/no-restricted-paths
    component: () => import('../pages/ExpiredToken.vue'),
    meta: {
      anonymous: true,
      redirectable: false,
    },
    name: RouteNames.ExpiredToken,
    path: '/expired-token',
  },
  {
    // eslint-disable-next-line import/no-restricted-paths
    component: () => import('../pages/LicenseExpired.vue'),
    meta: {
      anonymous: true,
      redirectable: false,
      track: false,
    },
    name: RouteNames.LicenseExpired,
    path: '/license-expired',
  },
  {
    // eslint-disable-next-line import/no-restricted-paths
    component: () => import('../pages/SessionExpired.vue'),
    meta: {
      anonymous: true,
      redirectable: false,
      track: false,
    },
    name: RouteNames.SessionExpired,
    path: '/session-expired',
  },
  {
    // eslint-disable-next-line import/no-restricted-paths
    component: () => import('../pages/TermsAndConditions.vue'),
    name: RouteNames.TermsAndConditions,
    path: '/terms-and-conditions',
  },

  // from here on only routes that don't have an explicit path.
  // That is, pages that will be displayed while the original
  // url is kept intact (e.g. 404, generic error)
  {
    // eslint-disable-next-line import/no-restricted-paths
    component: () => import('../pages/Error404.vue'),
    meta: {
      redirectable: false,
      track: false,
    },
    name: RouteNames.NotFound,
    path: '/:pathMatch(.*)*',
  },
  {
    // eslint-disable-next-line import/no-restricted-paths
    component: () => import('../pages/Error.vue'),
    meta: {
      anonymous: true,
      redirectable: false,
      track: false,
    },
    name: RouteNames.Error,
    path: '/:pathMatch(.*)*',
  },
  {
    // eslint-disable-next-line import/no-restricted-paths
    component: () => import('../pages/ErrorAlgorithm.vue'),
    meta: {
      redirectable: false,
      track: false,
    },
    name: RouteNames.NotFoundAlgorithm,
    path: '/:pathMatch(.*)*',
  },
]

export default routes
